import { Settings } from '@ais-ui/websockets';

export const isShapeShownOnStartUp = (
  settings: Settings,
  shapeId: string
): boolean => {
  return (
    settings?.['ribbonPlugin.settings']?.favorite_shapes?.shapes?.some(
      (favoriteShapeId: string) => favoriteShapeId === shapeId
    ) ?? false
  );
};

export const isShapeLabelShown = (
  settings: Settings,
  shapeId: string
): boolean => {
  return (
    settings?.['ribbonPlugin.settings']?.shape_labels?.some(
      (showLabelShapeId: string) => showLabelShapeId === shapeId
    ) ?? false
  );
};
